import RecoverAccountPage from '@glass/shared/components/Auth/pages/CreatePasswordPage';

export const getStaticProps = () => {
  return {
    props: {},
  };
};

export default RecoverAccountPage;
